export default "__VITE_ASSET__21711160__"